'use client';

import './style.scss';
import React from 'react';

import { CONTACT_US_ROUTE } from '@/app/[lang]/Router/routes';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { useTranslation } from '@/hooks/useTranslations';
import imagesCandyCrown from '@/public/assets/Images/prag/candy-crown.png';
import imagesPragBanner from '@/public/assets/Images/prag/hero.png';
import imagesPragMiniHero from '@/public/assets/Images/prag/mini-hero.png';
import imagesPragLogo from '@/public/assets/Images/prag/prag-logo.svg';
import imagesTornadoElement from '@/public/assets/Images/prag/tornado-el.png';
import imagesClover from '@/public/assets/Images/prag/tree-el.png';
import imagesTreeElement from '@/public/assets/Images/prag/tree-element.png';

import { PRAG_PAGE_TEXT_KEYS, WHY_PRAG_ITEMS } from './utils';

interface IProps {
  params: { lang: string };
}

export default function PragPage({ params }: IProps) {
  const { lang } = params;
  const { t } = useTranslation();

  return (
    <div className="land-rag-wrp">
      <div className="bigContent">
        <div className="land-based-banner-block">
          <div className="land-based-banner-info-wrp">
            <p className="land-based-banner-title">
              <Image src={imagesPragLogo} alt="" />
              <br />
              {t(PRAG_PAGE_TEXT_KEYS.bannerTitleFirstLine)} <br />{' '}
              {t(PRAG_PAGE_TEXT_KEYS.bannerTitleSecondLine)}
            </p>
            <p className="land-based-banner-subtitle">{t(PRAG_PAGE_TEXT_KEYS.bannerSubtitle)}</p>
          </div>
          <div className="land-based-banner-wrp">
            <Image src={imagesPragBanner} alt="" />
          </div>
        </div>
      </div>

      <div className="separator-container with-bg-img">
        <div className="left-bg-img light-left"></div>
        <div className="right-bg-img light-right"></div>
        <div className="mediumContent">
          {/*Linup start*/}
          <div className="why-prag-header">
            <h3 className="why-prag-header-title">{t(PRAG_PAGE_TEXT_KEYS.lineupTitle)}</h3>
            <p className="why-prag-header-desc">{t(PRAG_PAGE_TEXT_KEYS.lineupDescription)}</p>
          </div>

          <div className="games-lineup">
            <div className="games-lineup-cards">
              <div className="games-lineup-card games-lineup-card--wide card-money">
                <Image
                  className="games-lineup-card-decor"
                  src={imagesTreeElement}
                  alt="lineup-card-img"
                />
                <div className="lineup-card-info">
                  <div className="lineup-card-info-row">
                    <h3 className="games-lineup-card-info-title">Money Tree</h3>
                    <Image
                      className="games-lineup-card-img"
                      src={imagesPragLogo}
                      alt="lineup-card-img"
                    />
                  </div>
                  <div className="lineup-card-info-row">
                    <span className="lineup-card-info-label">
                      {t(PRAG_PAGE_TEXT_KEYS.goLiveDate)}
                    </span>
                    <span className="lineup-card-info-date">{t('COMING-SOON')}</span>
                  </div>
                </div>
              </div>

              <div className="games-lineup-card games-lineup-card--wide card-tornado">
                <Image
                  className="games-lineup-card-decor"
                  src={imagesTornadoElement}
                  alt="lineup-card-img"
                />
                <div className="lineup-card-info">
                  <div className="lineup-card-info-row">
                    <h3 className="games-lineup-card-info-title">Tor Nado</h3>
                    <Image
                      className="games-lineup-card-img"
                      src={imagesPragLogo}
                      alt="lineup-card-img"
                    />
                  </div>
                  <div className="lineup-card-info-row">
                    <span className="lineup-card-info-label">
                      {t(PRAG_PAGE_TEXT_KEYS.goLiveDate)}
                    </span>
                    <span className="lineup-card-info-date">{t('COMING-SOON')}</span>
                  </div>
                </div>
              </div>

              <div className="games-lineup-card games-lineup-card--narrow card-tree">
                <Image
                  className="games-lineup-card-decor"
                  src={imagesClover}
                  alt="lineup-card-img"
                />
                <div className="lineup-card-info">
                  <div className="lineup-card-info-row">
                    <h3 className="games-lineup-card-info-title">Clover Tree</h3>
                    <Image
                      className="games-lineup-card-img"
                      src={imagesPragLogo}
                      alt="lineup-card-img"
                    />
                  </div>
                  <div className="lineup-card-info-row">
                    <span className="lineup-card-info-label">
                      {t(PRAG_PAGE_TEXT_KEYS.goLiveDate)}
                    </span>
                    <span className="lineup-card-info-date">{t('COMING-SOON')}</span>
                  </div>
                </div>
              </div>
              <div className="games-lineup-card games-lineup-card--narrow card-bonbon">
                <div className="lineup-card-info">
                  <div className="lineup-card-info-row">
                    <h3 className="games-lineup-card-info-title">BON BON</h3>
                    <Image
                      className="games-lineup-card-img"
                      src={imagesPragLogo}
                      alt="lineup-card-img"
                    />
                  </div>
                  <div className="lineup-card-info-row">
                    <span className="lineup-card-info-label">
                      {t(PRAG_PAGE_TEXT_KEYS.goLiveDate)}
                    </span>
                    <span className="lineup-card-info-date">{t('COMING-SOON')}</span>
                  </div>
                </div>
              </div>
              <div className="games-lineup-card games-lineup-card--narrow card-candy">
                <Image
                  className="games-lineup-card-decor"
                  src={imagesCandyCrown}
                  alt="lineup-card-img"
                />
                <div className="lineup-card-info">
                  <div className="lineup-card-info-row">
                    <h3 className="games-lineup-card-info-title">Candy crown</h3>
                    <Image
                      className="games-lineup-card-img"
                      src={imagesPragLogo}
                      alt="lineup-card-img"
                    />
                  </div>
                  <div className="lineup-card-info-row">
                    <span className="lineup-card-info-label">
                      {t(PRAG_PAGE_TEXT_KEYS.goLiveDate)}
                    </span>
                    <span className="lineup-card-info-date">{t('COMING-SOON')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*Linup END*/}
        </div>
      </div>

      <div className="separator-container with-bg-img">
        <div className="left-bg-img donats-left"></div>
        <div className="right-bg-img donats-right"></div>
        <div className="bigContent">
          {/* WHY start */}
          <div className="why-prag-wrapper">
            <div className="why-prag-header">
              <h3 className="why-prag-header-title">{t(PRAG_PAGE_TEXT_KEYS.whyTitle)}</h3>
              <p className="why-prag-header-desc">{t(PRAG_PAGE_TEXT_KEYS.whyDescription)}</p>
            </div>
            <div className="why-prag-body">
              {WHY_PRAG_ITEMS.map((item) => (
                <div className="why-prag-body-item" key={item.titleKey}>
                  <div className="icon-container">
                    <i className="check-icon bc-i-checked"></i>
                  </div>
                  <div className="why-prag-body-content">
                    <p className="why-prag-body-name">{t(item.titleKey)}</p>
                    <p className="why-prag-body-desc">{t(item.descriptionKey)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* WHY END */}
        </div>
      </div>

      <div className="separator-container with-bg-img">
        <div className="left-bg-img candy-left"></div>
        <div className="right-bg-img candy-right"></div>
        <div className="bigContent">
          {/*  Become a partner start*/}
          <div className="why-prag-header">
            <h3 className="why-prag-header-title">
              {t(PRAG_PAGE_TEXT_KEYS.marketingMaterialsTitleFirstLine)} <br />{' '}
              {t(PRAG_PAGE_TEXT_KEYS.marketingMaterialsTitleSecondLine)}
            </h3>
            <p className="why-prag-header-desc">
              {t(PRAG_PAGE_TEXT_KEYS.marketingMaterialsDescription)}
            </p>
            <div className="becomePartnerLeftBtn">
              <a
                className="button btnTypeBig btnTypeOrange"
                href="https://clienthub.popokgaming.com"
                target="_blank"
              >
                <p>{t(PRAG_PAGE_TEXT_KEYS.visitNow)}</p>
                <i className="bc-i-go-to btnIcon btnIconSmall" />
              </a>
            </div>
          </div>
          <div className="becomePartnerHolder">
            <div className="becomePartnerLeftBlock becomePartnerLeftBlockPrag">
              <p className="becomePartnerLeftTitle">{t(PRAG_PAGE_TEXT_KEYS.becomePartnerTitle)}</p>
              <p className="becomePartnerLeftInfo">
                {t(PRAG_PAGE_TEXT_KEYS.becomePartnerInfoFirstLine)} <br />{' '}
                {t(PRAG_PAGE_TEXT_KEYS.becomePartnerInfoSecondLine)}
              </p>
              <div className="becomePartnerLeftBtn becomePartnerContactUs">
                <Link
                  href={CONTACT_US_ROUTE.getPath(lang)}
                  className="button btnTypeBig btnTypeWhite"
                >
                  <p>{t(PRAG_PAGE_TEXT_KEYS.contactUs)}</p>
                  <i className="bc-i-go-to btnIcon btnIconSmall" />
                </Link>
              </div>
            </div>
            <div className="becomePartnerImgBlock">
              <Image src={imagesPragMiniHero} alt="" />
            </div>
          </div>
          {/*  Become a partner END*/}
        </div>
      </div>
    </div>
  );
}
